import certificateMemoryCache from './certificateMemoryCache';

/**
 * Get certificate for current store and environment
 * Uses proactive memory cache - automatically reloads if mismatch detected via localStorage
 */
export async function getCertificate(storeId: string, env: string): Promise<string> {
  console.log(`[getCertificate] === REQUESTING CERTIFICATE FOR ${storeId}/${env} ===`);

  // The cache now handles sync checks and loading internally
  const certificate = await certificateMemoryCache.getCertificate(storeId, env);

  if (!certificate) {
    console.error(`[getCertificate] ❌ Certificate not available for ${storeId}/${env} even after proactive load!`);
    throw new Error(`Certificate not available for ${storeId}/${env}`);
  }

  console.log(`[getCertificate] ✅ Certificate retrieved successfully`);
  return certificate;
}
